import { render, staticRenderFns } from "./RegistrationDuplicateForm.vue?vue&type=template&id=7726a71e&"
import script from "./RegistrationDuplicateForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationDuplicateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports